import { useEffect, useRef, useState } from 'react';
import { Search, X } from 'lucide-react';
import type { PlannerData, RecordKind } from '../../types';
import { searchPlannerData } from '../../pages/search-utils';

type Props = {
  data: PlannerData;
  onClose: () => void;
  onOpenResult: (kind: RecordKind, id: string) => void;
  open: boolean;
};

export const SearchDialog = ({ data, onClose, onOpenResult, open }: Props) => {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [query, setQuery] = useState('');
  const results = searchPlannerData(data, query);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
    if (!open) setQuery('');
  }, [open]);

  return (
    <dialog className="search-dialog" ref={dialogRef} onCancel={onClose}>
      <div className="dialog-heading"><div><p className="eyebrow">On this device</p><h2>Search your planner</h2></div><button type="button" className="icon-button" aria-label="Close search" onClick={onClose}><X size={20} /></button></div>
      <label className="search-field"><Search size={19} aria-hidden="true" /><span className="sr-only">Search tasks, events, notes and shopping</span><input autoFocus value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Type a title or keyword" /></label>
      <div className="search-results" aria-live="polite">
        {!query.trim() && <p className="search-hint">Results stay in this browser. Nothing is sent anywhere.</p>}
        {query.trim() && results.length === 0 && <p className="search-hint">No matching planner items. Try another word.</p>}
        {results.map((result) => <button type="button" className="search-result" key={`${result.kind}-${result.id}`} onClick={() => onOpenResult(result.kind, result.id)}><span>{result.kind}</span><strong>{result.title}</strong>{result.excerpt && <small>{result.excerpt.slice(0, 140)}</small>}</button>)}
      </div>
    </dialog>
  );
};
